import WhiteLogo from './images/WhiteLogo.js';

const MainMenuHeader = () => {
    return (
        <table>
            <tbody>
                <tr>
                    <td align="left">
                        <h1 style={{color: "white"}}>SoftData</h1>
                    </td>
                    <td>
                        &nbsp;
                    </td>
                    <td align="right">
                        <WhiteLogo height={"60%"} width={"60%"}/>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default MainMenuHeader;